var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"show":true}}),_c('div',{staticClass:"container-fluid",staticStyle:{"margin-bottom":"65px"}},[_c('router-view')],1),_c('Bottom_actions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }